import { EMAIL_TEMPLATE_DETAILS,EMAIL_TEMPLATE_DETAILS_SUCCESS, EMAIL_TEMPLATE_DETAILS_FAILED, ADD_EMAIL_TEMPLATE,ADD_EMAIL_TEMPLATE_SUCCESS,ADD_EMAIL_TEMPLATE_FAILED,
    EDIT_EMAIL_TEMPLATE,EDIT_EMAIL_TEMPLATE_SUCCESS,EDIT_EMAIL_TEMPLATE_FAILED,
    GET_DEFAULT_EMAIL_TEMPLATE_DATA,GET_DEFAULT_EMAIL_TEMPLATE_DATA_SUCCESS, GET_DEFAULT_EMAIL_TEMPLATE_DATA_FAIL
} from "./actionTypes"


export const emailTemplateDetails = (payload) => {
   return {
       type: EMAIL_TEMPLATE_DETAILS,
       payload: payload
   }
}

export const emailTemplateDetailsSuccess = (payload) => {
   return {
       type: EMAIL_TEMPLATE_DETAILS_SUCCESS,
       payload: payload
   }
}



export const emailTemplateDetailsFailed = (payload) => {
   return {
       type: EMAIL_TEMPLATE_DETAILS_FAILED,
       payload: payload
   }
}


export const emailAddTemplate = (payload) => {
   return {
       type: ADD_EMAIL_TEMPLATE,
       payload: payload
   }
}

export const emailAddTemplateSuccess = (payload) => {

   return {
       type: ADD_EMAIL_TEMPLATE_SUCCESS,
       payload: payload
   }
}



export const emailAddTemplateFailed = (payload) => {
   return {
       type: ADD_EMAIL_TEMPLATE_FAILED,
       payload: payload
   }
}

export const emailEditTemplate = (payload) => {
   return {
       type: EDIT_EMAIL_TEMPLATE,
       payload: payload
   }
}

export const emailEditTemplateSuccess = (payload) => {
  
   return {
       type: EDIT_EMAIL_TEMPLATE_SUCCESS,
       payload: payload
   }
}



export const emailEditTemplateFailed = (payload) => {
   return {
       type: EDIT_EMAIL_TEMPLATE_FAILED ,
       payload: payload
   }
}


// email default template data
export const getEmailDefaultTemplate = (payload)=>{
    return{
        type: GET_DEFAULT_EMAIL_TEMPLATE_DATA,
        payload: payload
    }
}

export const getEmailDefaultTemplateSuccess = (payload)=>{
    return{
        type: GET_DEFAULT_EMAIL_TEMPLATE_DATA_SUCCESS,
        payload: payload
    }
}

export const getEmailDefaultTemplateFail = (payload)=>{
    return{
        type:  GET_DEFAULT_EMAIL_TEMPLATE_DATA_FAIL,
        payload: payload
    }
}
